package com.evoapps.evoshift.data.mapper

import com.evoapps.evoshift.data.dto.system.NotificationDto
import com.evoapps.evoshift.domain.model.Notification
import com.evoapps.evoshift.domain.model.NotificationType

class NotificationMapper {
    fun toDomain(dto: NotificationDto, userId: String): Notification {
        return Notification(
            id = dto.id,
            userId = userId,
            title = dto.title,
            message = dto.message,
            type = try { NotificationType.valueOf(dto.type) } catch (e: Exception) { NotificationType.GENERAL },
            createdAt = dto.createdAt,
            isRead = dto.isRead,
            data = dto.data
        )
    }

    fun toDto(domain: Notification): NotificationDto {
        return NotificationDto(
            id = domain.id,
            title = domain.title,
            message = domain.message,
            type = domain.type.name,
            createdAt = domain.createdAt,
            isRead = domain.isRead,
            data = domain.data
        )
    }
}
